import { Resource, HateoasResource } from '@lagoshny/ngx-hateoas-client';

// software-access resource from the customer-management service (served under customerURL).
// Surfaced to users as "Self Hosted". name may be absent (the resource may carry only an id),
// so callers resolve a display value as name || id.
@HateoasResource('software-accesses', { routeName: 'customerResourceRoute' })
export class SoftwareAccess extends Resource {
    id: string;
    name: string;
}
